import { Dialog } from "radix-ui";
import type { ComponentProps, ReactNode } from "react";

// The frame of the search dialog (⌘K): a modal panel near the top of the window on a scrim, as in the Paper mock-up. Radix traps focus,
// closes on Escape and marks the page behind as inert. The dialog always needs a title (`title`); it is read by a screen reader and not
// drawn, because the search field is the first thing a person sees. What is inside (the field and the list) belongs to the caller.

export function SearchDialog({
  open,
  onOpenChange,
  title,
  onCloseAutoFocus,
  children,
}: Readonly<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Where focus goes when the dialog closes. Radix has no trigger here, so the caller says. */
  onCloseAutoFocus?: ComponentProps<typeof Dialog.Content>["onCloseAutoFocus"];
  children: ReactNode;
}>) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[var(--lf-z-overlay)] bg-foreground/50" />
        <Dialog.Content
          aria-describedby={undefined}
          onCloseAutoFocus={onCloseAutoFocus}
          className="fixed top-[10vh] left-1/2 z-[var(--lf-z-modal)] grid max-h-[80vh] w-[min(40rem,calc(100vw-2rem))] -translate-x-1/2 grid-rows-[auto_minmax(0,1fr)] overflow-hidden rounded-2xl border border-border bg-popover text-popover-foreground shadow-lg outline-hidden"
        >
          <Dialog.Title className="sr-only">{title}</Dialog.Title>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
